var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7348_2116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 49
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7348_2116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9972 40.4999C14.1032 40.4999 13.3417 40.1853 12.7127 39.5559C12.0841 38.9263 11.7698 38.1639 11.7698 37.2689V12.4999H9.77197V10.4999H17.7631V8.96143H29.7498V10.4999H37.7409V12.4999H35.7431V37.2689C35.7431 38.1896 35.4351 38.9583 34.8191 39.5749C34.2032 40.1916 33.4353 40.4999 32.5157 40.4999H14.9972ZM33.7453 12.4999H13.7675V37.2689C13.7675 37.6279 13.8827 37.9229 14.1131 38.1539C14.3439 38.3846 14.6386 38.4999 14.9972 38.4999H32.5157C32.8234 38.4999 33.1052 38.3718 33.3613 38.1154C33.6173 37.8591 33.7453 37.5769 33.7453 37.2689V12.4999ZM19.3768 34.4999H21.3746V16.4999H19.3768V34.4999ZM26.1383 34.4999H28.1361V16.4999H26.1383V34.4999Z",
    fill: "#FF3434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/deleteRed.6c424b84addc39c90ddfa24f26c1660b.svg";
export { ForwardRef as ReactComponent };